import { useState, useEffect } from 'react';
import { getStoreList } from '../actions/storeActions';

let cachedStoreList = null;


export const useCompaniesList = (axiosInstance) => {
  const [storeList, setStoreList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cachedStoreList) {
        setStoreList(cachedStoreList);
        setLoading(false);
        return;
      }

    let isMounted = true;
    
    const fetchStoreList = async () => {
      try {
        setLoading(true);
        const response = await getStoreList(axiosInstance);
        if (isMounted) {
          setStoreList(response);
          setError(null);
        }

        cachedStoreList = response;
      } catch (err) {
        if (isMounted) {
          cachedStoreList = null;
          console.error('Error fetching store list : ', err);
          setError(err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchStoreList();

    return () => {
      isMounted = false;
    };
  }, [axiosInstance]);

  return { storeList, loading, error };
};